/**
 * How many generations one request may queue. The api clamps to it and the
 * frontend's generations dropdown is built from it, so the cap can't drift
 * between the two.
 *
 * @input MAX_GENERATIONS_PER_REQUEST  @output 4
 */
export const MAX_GENERATIONS_PER_REQUEST = 4

/** Dropdown options: [1 … MAX_GENERATIONS_PER_REQUEST]. */
export const GENERATION_COUNT_OPTIONS: number[] = Array.from(
    { length: MAX_GENERATIONS_PER_REQUEST },
    (_, index) => index + 1,
)
